import {
  Button,
  Modal,
  Alert
} from "react-bootstrap";
import React from "react";

export const ConfirmRelocationModal = ({show, user, handleClose, handleClick}) => {

  if (!user)
    return<></>;
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Relocation for user {user.phoneNumber}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant='success'>
            the relocation button will be enabled for user {user.phoneNumber}
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" onClick={()=>handleClick(user)}>Confirm</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
